import { createSlice } from '@reduxjs/toolkit';
import { IAlertList, IAlertHistory } from '@models/manager/account/accountModel';
import { fetchAlertList, fetchAlertEnable, fetchAlertHistoryList } from './thunks/alertThunk';
import { alertTypeObj } from '@models/manager/account/account';

const initialState = {
  alertList: null as IAlertList[],
  historyList: null as IAlertHistory[],
  alertBoxType: alertTypeObj.listBox,
};

export const alertSlice = createSlice({
  name: 'alert',
  initialState: initialState,
  reducers: {
    // setAlertBoxType
    setAlertBoxType: (state, { payload }: { payload: { boxType: alertTypeObj } }) => {
      state.alertBoxType = payload.boxType;
    },
  },
  extraReducers: {
    // alertList 가져오기
    [fetchAlertList.fulfilled.type]: (state, { payload }) => {
      state.alertList = payload;
    },
    // enable alertList 처리
    [fetchAlertEnable.fulfilled.type]: (state, { payload }: { payload: { alertId: string; enable: boolean } }) => {
      const { alertId, enable } = payload;
      const objIndex = state.alertList.findIndex((item) => item.id === alertId);
      state.alertList[objIndex].enable = !enable;
    },
    // // create alert 처리
    // [fetchCreateAlert.fulfilled.type]: (state, { payload }) => {
    //   // alert 만등 후 재요청된 alertList 를 다시 적용시킴
    //   state.alertList = payload;
    // },
    // alertHistoryList 가져오기
    [fetchAlertHistoryList.fulfilled.type]: (state, { payload }) => {
      state.historyList = payload;
    },
  },
});

export const { setAlertBoxType } = alertSlice.actions;
export const alertSliceName = alertSlice.name;
export default alertSlice.reducer;
